( $ => {
  const formDiv = $( '.bs-div--pricing-form' );
  if ( formDiv.length === 0 ) return;

  const formElement = formDiv.find( '.wpcf7-radio label' ),
    spanElement = $( '<span class="check-icon"></span>' ),
    radioBtn = formDiv.find( '.wpcf7-radio input[type=radio]' ),
    existingSubmitBtn = formDiv.find( 'input.wpcf7-submit' ),
    newSubmitBtn = $( '<button type="submit" value="Apply"></button>' );

  existingSubmitBtn.parent().addClass( 'position-relative' );

  newSubmitBtn.attr( 'class', existingSubmitBtn.attr( 'class' ) );
  newSubmitBtn.html( existingSubmitBtn.val() );
  existingSubmitBtn.replaceWith( newSubmitBtn );

  // Append the <span> element after the input field
  formElement.append( spanElement );

  // Add active class to the default checked
  formDiv.find( '.wpcf7-radio input[type=radio]:checked' ).parent().addClass( 'active' );

  radioBtn.on( 'click', e => {
    formElement.removeClass( 'active' );
    $( e.target ).parent().addClass( 'active' );
  } );
} )( jQuery );
